import { render, staticRenderFns } from "./RootCauseAnalysisChart.vue?vue&type=template&id=226d91d7&scoped=true&"
import script from "./RootCauseAnalysisChart.vue?vue&type=script&lang=js&"
export * from "./RootCauseAnalysisChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d91d7",
  null
  
)

export default component.exports